import { render, staticRenderFns } from "./ResponseChartTwo.vue?vue&type=template&id=5f588270&scoped=true&"
import script from "./ResponseChartTwo.vue?vue&type=script&lang=js&"
export * from "./ResponseChartTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f588270",
  null
  
)

export default component.exports